namespace $.$$ {

	export class $shm_ba_converter extends $.$shm_ba_converter {

		data() {
			return super.data() as $shm_ba_data
		}

		limit() {
			return Math.max( 0, Math.floor( Number( this.limit_text().replaceAll( /\s/g, '' ) ) || 0 ) )
		}

		export_key( format: $shm_ba_data_export_format ) {
			return `${ format }:${ this.limit() }`
		}

		csv_file_name() {
			return this.data().export_file_name( 'csv', this.limit() )
		}

		parquet_file_name() {
			return this.data().export_file_name( 'parquet', this.limit() )
		}

		duckdb_file_name() {
			return this.data().export_file_name( 'duckdb', this.limit() )
		}

		csv_blob() {
			return this.data().export_csv_blob( this.export_key( 'parquet' ) )
		}

		parquet_blob() {
			return this.data().export_blob( this.export_key( 'parquet' ) )
		}

		duckdb_blob() {
			return this.data().export_duckdb_blob( this.export_key( 'parquet' ) )
		}

	}

}
